import { render, staticRenderFns } from "./BankDetailsFields.vue?vue&type=template&id=3a59f660"
import script from "./BankDetailsFields.vue?vue&type=script&lang=js"
export * from "./BankDetailsFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports